// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8hmM2","checkboxList":"styles_checkboxList__k6txN"};